import apiClient from './apiClient';

export interface F90T1Member {
  f90t1_id?: number;
  f90t1_01: string;
  f90t1_02: number;
  f90t1_11: string;   // 員工代號
  f90t1_11a: string;  // 員工姓名
}

export interface F90T {
  f90t_01: string;
  f90t_11: string;
  f90t_21: number;
  f90t_91: string;
  f90t_92: string | null;
  f90t_93: string;
  members?: F90T1Member[];
}

export interface MemberRequest {
  f90t1_11: string;
  f90t1_11a: string;
}

export interface ListResponse {
  data: F90T[];
  total: number;
  page: number;
  size: number;
}

export const empGroupApi = {
  async list(page = 1, size = 500, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/emp-group', { params });
    return res.data;
  },

  async get(code: string): Promise<F90T> {
    const res = await apiClient.get(`/api/emp-group/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: { f90t_01: string; f90t_11: string; members: MemberRequest[] }): Promise<F90T> {
    const res = await apiClient.post('/api/emp-group', data);
    return res.data;
  },

  async update(code: string, data: { f90t_11: string; members: MemberRequest[] }): Promise<F90T> {
    const res = await apiClient.put(`/api/emp-group/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async copy(data: { new_code: string; from_code: string }): Promise<F90T> {
    const res = await apiClient.post('/api/emp-group/copy', data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/emp-group/${encodeURIComponent(code)}`);
  },
};
